import React from 'react';
import { AudioFile } from '../../types';
import EntityHeader from '../ui/EntityHeader';

interface FileHeaderProps {
  audioFile: AudioFile;
}

const FileHeader: React.FC<FileHeaderProps> = ({ audioFile }) => {
  const metadata = [
    {
      label: 'File Size',
      value: audioFile.fileSizeDisplay,
    },
    {
      label: 'Duration',
      value: audioFile.durationDisplay,
      show: !!audioFile.durationDisplay,
    },
    {
      label: 'Format',
      value: audioFile.contentType?.split('/')[1]?.toUpperCase(),
    },
    {
      label: 'Created',
      value: new Date(audioFile.createdAt).toLocaleDateString(),
    },
  ];

  return (
    <EntityHeader
      title={audioFile.name}
      statusVariant={audioFile.status as any}
      metadata={metadata}
    />
  );
};

export default FileHeader;
